import { render } from "./CatSvg.vue?vue&type=template&id=1f13a824"
import script from "./CatSvg.vue?vue&type=script&lang=js"
export * from "./CatSvg.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__